import { getDatabase, ref, set as FirebaseSet, push as FirebasePush , get, remove as FirebaseRemove} from 'firebase/database';
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import searchData from './data/search.json';
import { DropdownButton, Dropdown } from 'react-bootstrap';

export default function Search(props) {

    var plans = props.plans;
    const setPlan = props.setPlan;
    const db = getDatabase();
    const username = props.username;

    const searchDataKeys = Object.keys(searchData);
    var temp = searchDataKeys.map((key) => {
        const singleData = {...searchData[key]};
        return singleData;
    });


    const allOptions = {Credits: {value: [1, 2, 3, 4, 5, 100], desc: ["1", "2", "3", "4", "5", "6+"]},
                        Genres: {value: ['qsr', 'iands', 'vlpa', 'nw', 'div', 'w', 'c'], desc: ["QSR", "I&S", "VLPA", "NW", "DIV", "W", "C"]},
                        Levels: {value: [1, 2, 3, 4, 100], desc: ["100", "200", "300", "400", "500+"]}};

    const pageItm = 4;

    const [query, setQuery] = React.useState("");
    const [tempQuery, setTemp] = React.useState("");
    const [filterCredit, setCredit] = React.useState(new Array(allOptions["Credits"]["value"].length).fill(false));
    const [filterGenre, setGenre] = React.useState(new Array(allOptions["Genres"]["value"].length).fill(false))
    const [filterLevel, setLevel] = React.useState(new Array(allOptions["Levels"]["value"].length).fill(false))
    const [currPage, setPage] = React.useState(0);
    const [isLoading, setLoading] = React.useState(false);

    const allData = temp;

    var optionCreditCallback = (index) => {
        filterCredit[index] = !filterCredit[index];
        setCredit([...filterCredit]);
    }

    var optionsGenreCallback = (index) => {
        filterGenre[index] = !filterGenre[index];
        setGenre([...filterGenre]);
    }

    var optionLevelCallback = (index) => {
        filterLevel[index] = !filterLevel[index];
        setLevel([...filterLevel]);
    }

    var tempCallback = (evt) => {
        setTemp(evt.target.value);
        if (evt.key === 'Enter' || tempQuery === "") {
            setQuery(tempQuery);
        }
    }


    
    const changeDatabasePlan = (newPlans) => {
        setPlan(newPlans);
        var location = "users/" + username;
        const courseUpload = ref(db, location);
        FirebaseRemove(courseUpload);
        newPlans.forEach((plan) => {
            plan['key'] = null;
            FirebasePush(courseUpload, plan)
        });
        const placeholder = {"placeholder": 0};
        const placeholderRef = ref(db, location + "/placeholder");
        FirebaseSet(placeholderRef, placeholder);
    }

    const addCourseCallback = (keys, code) => {
        const newClassObj = {};
        newClassObj[code] = new Array(1).fill(0);

        var newPlan = plans.map((singlePlan) => {
            var currClass = singlePlan['plan'].filter((singleClass) => {return Object.keys(singleClass).includes(code)});
            if(keys.includes(singlePlan['key']) && currClass.length === 0) {
                //target plan
                singlePlan['plan'].push(newClassObj);
            }
            return singlePlan;
        })
        changeDatabasePlan(newPlan);
    }
    
    var processedData = [];

    var creditAllFalse = filterCredit.every(singleChk => !singleChk);
    var genreAllFalse = filterGenre.every(singleChk => !singleChk);
    var levelAllFalse = filterLevel.every(singleChk => !singleChk);

    var queryWords = query.trim().toLowerCase().split(" ");

    if (allData !== null) {
        allData.forEach(singleCourse => {
            var validCredit = true;
            var validGenre = true;
            var validLevel = true;
            var validQuery = true;
            var tempIndex;
            
            if (query.trim() !== "") {
                var classWords = "" + singleCourse['code'] + ' ' + singleCourse['name'] + ' ' + singleCourse['type'] + ' ' + singleCourse['credit'] + " credits";
                classWords = classWords.trim().replace(/\n/g, " ").toLowerCase().split(' ');
                validQuery = queryWords.every(word => classWords.includes(word));
            }

            //credit Check
            if (!creditAllFalse) {
                singleCourse["credit"].forEach(singleCredit => {
                    singleCredit = singleCredit > 5 ? 100 : singleCredit;
                    tempIndex = allOptions["Credits"]["value"].indexOf(singleCredit);
                    if (filterCredit[tempIndex]) {
                        validCredit = true;
                    }
                    else {
                        validCredit = false;
                    }
                });  
            }
            if (!genreAllFalse) {
                singleCourse["type"].split(" ").forEach(word => {
                    tempIndex = allOptions["Genres"]["value"].indexOf(word);
                    if (tempIndex !== -1 && filterGenre[tempIndex]) {
                        validGenre = true;
                    }
                    else {
                        validGenre = false;
                    }
                });  
            } 
            if (!levelAllFalse) {

                var tempCode = singleCourse['code'].split(" ");
                var singleLevel = parseInt(tempCode[tempCode.length - 1]);
                singleLevel = Math.floor(singleLevel / 100);
                singleLevel = singleLevel > 5 ? 100 : singleLevel;
                tempIndex = allOptions["Levels"]["value"].indexOf(singleLevel);
                if (filterLevel[tempIndex]) {
                    validLevel = true;
                }
                else {
                    validLevel = false;
                }
            }


            if (validCredit && validGenre && validLevel && validQuery) {
                processedData.push(singleCourse);
            }

        });
    }
    
    var creditOptions = <RenderOptions title={"Credits"} options={allOptions["Credits"]["value"]} optionsTitle={allOptions["Credits"]["desc"]} optionsCallback={optionCreditCallback} />
    var genreOptions = <RenderOptions title={"General Education"} options={allOptions["Genres"]["value"]} optionsTitle={allOptions["Genres"]["desc"]} optionsCallback={optionsGenreCallback} />
    var levelOptions = <RenderOptions title={"Level"} options={allOptions["Levels"]["value"]} optionsTitle={allOptions["Levels"]["desc"]} optionsCallback={optionLevelCallback} />
    
    var resultCards = (<p>No Result</p>);
    var pageNum = Math.floor((processedData.length - 0.5) / pageItm) + 1;
    console.log(pageNum);
    var pagedData = processedData.slice(currPage * pageItm, currPage * pageItm + pageItm);

    if (pagedData.length !== 0) {
        resultCards = pagedData.map((singleCard) => {
            return <RenderSingleClass key={[singleCard["code"]]} singleCard={singleCard} allData={allData} addCourseCallback={addCourseCallback} plans={plans}/>;
        });
    }

    return (
        <div className="mainfunc-block">
            <div className="sidebar-view">
                <div className="search-options">
                    <div className="mb-2">
                        <label htmlFor="searchKeyword" className="form-label calendar-titles">Search by Keyword</label>
                        <input type="keyword" className="form-control" id="searchKeyword" aria-describedby="searchKeyword" onKeyUp={()=>{tempCallback()}} placeholder="Press Enter to Seach"/>
                        <div id="searchHelp" className="form-text">e.g. INFO 340, Intro to Neuroscience, VLPA</div>
                    </div>

                    <button className="btn btn-primary mb-2" onClick={() => {setQuery(tempQuery);}}>Search</button>

                    <div className="divider"></div>

                    <form>
                        {creditOptions}

                        {genreOptions}

                        {levelOptions}

                       </form>
                </div>
                <div className="search-results">
                    <div className="calendar-titles">
                        {isLoading ? "Loading Result" : "Search Result"}
                    </div>
                    <div className="result-group">
                        <div className="result-cards">
                            {resultCards}
                        </div>

                        <RenderPagination currPage={currPage} setPage={setPage} pageNum={pageNum} />
                    </div>
                </div>
            </div>

        </div>
    );
}


function RenderSingleClass(props) {
    var plans = props.plans;
    const addCourseCallback = props.addCourseCallback;
    var classInfo = props.singleCard;
    var type = classInfo.type;
    var introStr = "";
    var typeStr = "";

    if (type !== "") {
        typeStr = type.split(" ");
    }

    introStr = convertGenEd(type);
    
    var creditAry = classInfo["credit"];
    var creditStr = "" + creditAry[0] + " Credits";
    if (creditAry.length > 1) {
        creditStr = "" + creditAry[0] + "-" + creditAry[0] + " Credits";
    }

    introStr += ("• " + creditStr);

    var resultBtn;
    if (plans.length === 0) {
        resultBtn = (
            <DropdownButton className="btn btn-outline-primary course-card-btn course-card-btn__secondary" title="Creat a plan first" disabled={true}>
            </DropdownButton>
        );
    }
    else {
        var allKeys = [];
        var courseCode = classInfo.code;
        var dropdownContent = plans.map((singlePlan, index) => {
            var key = singlePlan['key'];
            var keys = [];
            keys.push(key);
            allKeys.push(key);
            var name = singlePlan['name'];
            return (<Dropdown.Item as="button" key={index} onClick={()=>{addCourseCallback(keys, courseCode)}}>{name}</Dropdown.Item>)
        })

        dropdownContent.push((
            <Dropdown.Divider key={-2}/>
        ))

        dropdownContent.push((
            <Dropdown.Item as="button" key={-1} onClick={()=>{addCourseCallback(allKeys, courseCode)}}>Add to All Plans</Dropdown.Item>
        ));

        resultBtn = (
        <DropdownButton title="Add to Plan" disabled={false} className="btn course-card-btn course-card-btn__secondary">
            <Dropdown.ItemText key={-1}>Select Plan</Dropdown.ItemText>
            {dropdownContent}
        </DropdownButton>
        );
    }
    
    return (
        <div className={["card border-dark mb-3 " + typeStr[0]]}>
            <div className="card-header">{introStr}</div>
            <div className="card-body text-dark">
                <p className="card-title">{classInfo.code} • {classInfo.name}</p>
                <p className="card-text">{classInfo.info}</p>
                <Link className="btn btn-primary course-card-btn course-card-btn__main" to={"/detail/" + classInfo.code}>View</Link>
                {resultBtn}
            </div>
        </div>
    )
}

function RenderOptions(props) {
    var options = props.options;
    var optionsTitle = props.optionsTitle;
    var optionsCallBack = props.optionsCallback;
    var title = props.title;

    const optionLst = options.map((option, index) => {
        return <RenderSingleOption key={[title + "-" + index]} option={option} optionTitle={[optionsTitle[index]]} index={index} optionsCallBack={optionsCallBack} title={title}/>
    })

    return (
        <div className="mb-2">
            <div className="calendar-titles">{title}</div>
            {optionLst}
        </div>
    )
}

function RenderSingleOption(props) {
    var optionTitle = props.optionTitle;
    var optionsCallBack = props.optionsCallBack;
    var title = props.title;
    var index = props.index;

    return (
        <div className="form-check">
            <input type="checkbox" className="form-check-input" onChange={() => {optionsCallBack(index)}}/>
            <label className="form-check-label" htmlFor={[title + "-" + optionTitle]}>
                {optionTitle}
            </label>
        </div>
    )
}

function RenderPagination(props) {
    var currPage = props.currPage;
    var setPage = props.setPage;
    var pageNum = props.pageNum;
    var pageAry = [...Array(pageNum).keys()];

    var pgBtns = pageAry.map(i => {
        var pgBtn = (
            <li className="page-item" key={i.toString()}>
                <button className="page-link" onClick={()=>{setPage(i)}}>{[i + 1]}</button>
            </li>
        );

        if (i === currPage) {
            pgBtn = (
            <li className="page-item active" key={i.toString()} aria-current={["page " + [i+1]]}>
                <button className="page-link" onClick={()=>{setPage(i)}}>{[i + 1]}</button>
            </li>
            );
        }

        return pgBtn;
    });

    var preEnable = currPage === 0 ? " disabled" : "";
    var nxtEnable = currPage === (pageNum - 1) ? " disabled" : "";

    return (
        <div className="result-pagination">
            <nav aria-label="Page navigation for Search Result">
                <ul className="pagination">
                    <li className={["page-item" + preEnable]} key={-1}>
                        <button className="page-link" onClick={()=>{setPage(currPage - 1)}}>Previous</button>
                    </li>

                    {pgBtns}

                    <li className={["page-item" + nxtEnable]} key={-2}>
                        <button className="page-link" onClick={()=>{setPage(currPage + 1)}}>Next</button>
                    </li>

                </ul>
            </nav>
        </div>
    )
}

export function convertGenEd(type) {
    const classType = {"qsr": ["QSR", "Quantitative and Symbolic Reasoning"], nw: ["NW", "The Natural World"], vlpa: ["VLPA", "Visual, Literary, and Performing Arts"], "iands": ["I&S", "Individuals and Societies"], "div": ["DIV", "Diversity"], "c": ["C", "English Composition"], "w": ["W", "Additional Writing"]};
    var introStr = "";
    var typeStr = "";

    if (type !== "") {
        typeStr = type.split(" ");
        typeStr.forEach(word => {
            if (Object.keys(classType).includes(word)) {
                introStr += "(" + classType[word][0] + ") " + classType[word][1] + " ";
            }
            else {
                introStr += " " + word + " ";
            }
        })
    }
    else {
        introStr = "No Gen Ed ";
    }

    return introStr
}